import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ValidationPattern } from '../../../utils/validation/regx';
import { ClockIcon } from '~svg';
import './timePicker.scss';
class TimePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hour: '00',
      minute: '00',
      handleType: 'hour',
      timeFlag: 'hourFlag',
      clockHandPotion: '0',
      display: 'block',
      setAmPm: 'AM',
      timeFormat: '',
      showDropDown: false,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  pairedNumber = [
    {
      topNum: { hour: 12, minute: '00' },
      bottomNum: { hour: 6, minute: 30 },
      rotate: 'rotate-0deg',
      rotateRev: '',
    },
    {
      topNum: { hour: 1, minute: 5 },
      bottomNum: { hour: 7, minute: 35 },
      rotate: 'rotate-30deg',
      rotateRev: 'rotate(-30deg)',
    },
    {
      topNum: { hour: 2, minute: 10 },
      bottomNum: { hour: 8, minute: 40 },
      rotate: 'rotate-60deg',
      rotateRev: 'rotate(-60deg)',
    },
    {
      topNum: { hour: 3, minute: 15 },
      bottomNum: { hour: 9, minute: 45 },
      rotate: 'rotate-90deg',
      rotateRev: 'rotate(-90deg)',
    },
    {
      topNum: { hour: 4, minute: 20 },
      bottomNum: { hour: 10, minute: 50 },
      rotate: 'rotate-120deg',
      rotateRev: 'rotate(-120deg)',
    },
    {
      topNum: { hour: 5, minute: 25 },
      bottomNum: { hour: 11, minute: 55 },
      rotate: 'rotate-150deg',
      rotateRev: 'rotate(-150deg)',
    },
  ];

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    const { value } = this.props;
    const currentTime = new Date();
    const hour = value ? value.split(':')[0] : currentTime.getHours();
    const minute = value ? value.split(':')[1] : currentTime.getMinutes();
    this.setState({
      hour:
        hour > 12
          ? hour - 12 < 10
            ? `${hour - 12}`
            : hour - 12
          : hour < 10
          ? `${hour}`
          : hour,
      minute: minute < 10 ? `${minute}` : minute,
      setAmPm: hour > 12 ? 'PM' : 'AM',
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.state.timeFormat) {
      const timeArray = value.split(':');
      const hour = +timeArray[0].trim();
      const minute = +timeArray[1].trim();
      if (+timeArray[0].trim() <= 12) {
        this.setState({
          hour: hour < 10 ? `0${hour}` : hour,
          minute: minute < 10 ? `0${minute}` : minute,
          setAmPm: 'AM',
          timeFormat: value,
        });
      } else {
        this.setState({
          hour: hour - 12 < 10 ? `0${hour - 12}` : hour - 12,
          minute: minute < 10 ? `0${minute}` : minute,
          setAmPm: 'PM',
          timeFormat: value,
        });
      }
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        showDropDown: false,
      });
    }
  }

  handleResetTime = () => {
    const currentTime = new Date();
    const hour = currentTime.getHours();
    const minute = currentTime.getMinutes();
    this.setState({
      hour:
        hour > 12
          ? hour - 12 < 10
            ? `0${hour - 12}`
            : hour - 12
          : hour < 10
          ? `0${hour}`
          : hour,
      minute: minute < 10 ? `0${minute}` : minute,
      handleType: 'hour',
      setAmPm: hour > 12 ? 'PM' : 'AM',
      timeFormat: `${hour}:${minute}`,
      showDropDown: false,
    });
  };

  handleSetTime = () => {
    const { hour, minute, setAmPm } = this.state;
    const formatHour = `${
      setAmPm === 'AM'
        ? `${hour}`.padStart(2, '0')
        : hour == 12 || hour == 0
        ? '00'
        : +hour + 12
    }`;
    const formatMinute = `${minute}`.padStart(2, '0');
    const timeFormat = `${formatHour}:${formatMinute}`;
    this.setState({ timeFormat, showDropDown: false });
    this.props.handleSubmit(timeFormat);
  };

  Validation = (key, value) => {
    if (value.length) {
      const isValid = ValidationPattern.intNumber.test(value);
      if (key === 'hour' && value.length < 3 && value <= 12 && isValid) {
        this.setState({
          [key]: value,
        });
      }
      if (key === 'minute' && value.length < 3 && value < 60 && isValid) {
        this.setState({
          [key]: value,
        });
      }
    } else {
      this.setState({
        [key]: '00',
      });
    }
  };
  render() {
    const { handleType, hour, minute, setAmPm, display, showDropDown } =
      this.state;
    const {
      outsideLabel,
      workingHours,
      label,
      isAnalog,
      value,
      language,
      parentClassName,
    } = this.props;
    return (
      <>
        {outsideLabel ? (
          <label className="w-100 d-flex font-small text-dark px-3 pb-2 m-0">
            {label}
          </label>
        ) : (
          value && (
            <label className="w-100 d-flex font-small text-dark px-3 pb-2 m-0">
              {label}
            </label>
          )
        )}
        <div
          className={`height-55px flex-column align-items-center justify-content-start font unselect bg-white direction-ltr timePicker-component position-relative ${parentClassName}`}
          ref={this.setWrapperRef}
        >
          <p
            className={`d-flex h-100 align-items-center justify-content-end cursor-pointer px-3 m-0 h-show-elemet time-picker-border bg-third-light text-dark
            ${language.direction === 'rtl' ? 'flex-row' : 'flex-row-reverse'} ${
              !showDropDown ? 'time-picker-rounded' : 'time-picker-rounded-top'
            }`}
            onClick={() => this.setState({ showDropDown: !showDropDown })}
          >
            <span className="d-flex align-items-center px-3 mt-1 direction-ltr text-nowrap">{`${hour} : ${minute} ${setAmPm}`}</span>
            <ClockIcon color="#00798C" size={20} />
          </p>
          <div
            className={`w-100 flex-column align-items-center justify-content-between position-absolute bg-third-light time-picker-border time-picker-zIndex ${
              showDropDown
                ? 'd-flex time-picker-rounded-bottom shadow'
                : 'd-none'
            }`}
          >
            <div
              className={`w-100 row px-0 ${
                workingHours && 'pt-3'
              } m-0 align-items-center justify-content-center`}
            >
              <div className="col-10 d-flex align-items-center justify-content-around">
                <div className="col-4 d-flex align-items-center justify-content-center p-0 fontVw-xlarge">
                  <input
                    id="hour"
                    className={`w-100 d-flex align-items-center justify-content-center text-center p-2 border rounded timepicker-ui-hour timepicker-ui-normalize
                  ${handleType === 'hour' ? 'active' : ''}`}
                    type="number"
                    min="0"
                    max="13"
                    onClick={() => {
                      this.setState({
                        handleType: 'hour',
                      });
                    }}
                    onChange={(event) => {
                      const { value } = event.target;
                      this.Validation('hour', value <= 12 ? value : '01');
                    }}
                    value={hour}
                    tabIndex="1"
                  />
                </div>
                <span
                  className={`p-0 d-flex align-items-center justify-content-center timepicker-ui-dots fontVw-xxlarge
                `}
                >
                  :
                </span>
                <div className="col-4 d-flex align-items-center justify-content-center p-0 fontVw-xlarge">
                  <input
                    id="minute"
                    className={`w-100 d-flex align-items-center justify-content-center text-center p-2 border rounded timepicker-ui-hour timepicker-ui-normalize
                  ${handleType === 'minute' ? 'active' : ''}`}
                    type="number"
                    min="0"
                    max="60"
                    step="5"
                    onClick={() => {
                      this.setState({
                        handleType: 'minute',
                      });
                    }}
                    onChange={(event) => {
                      const { value } = event.target;
                      this.Validation('minute', value > 55 ? '00' : value);
                    }}
                    value={minute}
                    tabIndex="2"
                  />
                </div>
              </div>
              <div className="col-2 d-flex align-items-center justify-content-center flex-column timepicker-ui-wrapper-type-time fontVw-large py-2">
                <span
                  className={`transition-all timepicker-ui-type-mode timepicker-ui-am
                  ${setAmPm === 'AM' ? 'active' : ''}`}
                  role="button"
                  data-type="AM"
                  onClick={() => {
                    this.setState({
                      setAmPm: 'AM',
                    });
                  }}
                >
                  AM
                </span>
                <span
                  className={`transition-all timepicker-ui-type-mode timepicker-ui-pm
                  ${setAmPm === 'PM' ? 'active' : ''}`}
                  role="button"
                  data-type="PM"
                  onClick={() => {
                    this.setState({
                      setAmPm: 'PM',
                    });
                  }}
                >
                  PM
                </span>
              </div>
            </div>
            {isAnalog && (
              <div className={`w-50 frame-face`}>
                <div
                  className="position-relative rounded-circle d-flex align-items-center justify-content-center clock-handle-container"
                  style={{
                    transform: `rotate(${
                      handleType === 'hour' ? +hour * 30 : +minute * 6
                    }deg)`,
                  }}
                >
                  <span className="d-flex rounded-circle bg-clock-handle clock-center"></span>
                  <span className="d-flex position-absolute bg-clock-handle clock-handle"></span>
                  <span className="d-flex position-absolute rounded-circle bg-clock-handle clock-selector"></span>
                </div>
                <div className="w-100 rounded-circle d-flex flex-column align-items-center justify-content-between position-relative clock-container time-picker-ratio-1x1 translateY-n100">
                  {this.pairedNumber.map((number, index) => {
                    const { bottomNum, topNum, rotate, rotateRev } = number;
                    return (
                      <span
                        key={index}
                        className={`h-100 col-1 p-0 d-flex flex-column align-items-center justify-content-between position-absolute ${rotate}`}
                      >
                        <b
                          className="w-100 d-flex align-items-center justify-content-center rounded-circle cursor-pointer time-picker-ratio-1x1"
                          id={topNum[handleType]}
                          onClick={(event) => {
                            const { id } = event.target;
                            this.setState({ [handleType]: id });
                          }}
                        >
                          {topNum[handleType]}
                        </b>
                        <b
                          className="w-100 d-flex align-items-center justify-content-center text-dark-main rounded-circle cursor-pointer time-picker-ratio-1x1"
                          id={bottomNum[handleType]}
                          onClick={(event) => {
                            const { id } = event.target;
                            this.setState({ [handleType]: id });
                          }}
                        >
                          {bottomNum[handleType]}
                        </b>
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
            <div
              className={`w-100 d-flex ${
                workingHours && 'flex-column-reverse'
              } align-items-center justify-content-end mt-4`}
            >
              <div
                className={`${
                  workingHours ? 'col-6' : 'col-2'
                } timepicker-ui-cancel-btn transition-all font-weight-bold mb-3 mx-3`}
                role="button"
                aria-pressed="false"
              >
                <span className="text-dark" onClick={this.handleResetTime}>
                  CANCEL
                </span>
              </div>
              <div
                className={`${
                  workingHours ? 'col-6' : 'col-2'
                } timepicker-ui-ok-btn transition-all font-weight-bold mb-3 mx-3`}
                role="button"
                aria-pressed="false"
                onClick={this.handleSetTime}
              >
                <span className="text-dark">OK</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
TimePicker.defaultProps = {
  language: { name: 'en', direction: 'ltr' },
};

TimePicker.propTypes = {
  language: PropTypes.object,
};
export default TimePicker;
